<template>
   <div class="panel panel-default" style="border: 1px solid #ccc; background-color: white">
    <legend>Units</legend>
      <div v-for="unit in units" :key="unit.Id">
          <core-unit :unit="unit"></core-unit>
      </div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
      <div v-if="reachedTheEnd">
        All Loaded
      </div>
      <div v-else>
        <button @click="fetchData">Load More</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    community_id: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      units: [],
      page: 1,
      pageCount: 0,
      loading: false,
    };
  },
  computed: {
    reachedTheEnd() {
      console.log(this.page > this.pageCount)
      return this.page > this.pageCount;
    }
  },
  methods: {
    fetchData() {
      if (this.loading) return;
      this.loading = true;
      var url = "/core/unit2?community=" + this.community_id;
      console.log(this.page);
      axios.get(url + `&page=${this.page}`)
        .then((response) => {
          console.log(response.data);
          this.units = this.units.concat(response.data.data);
          console.log(this.page);
          this.page++;
          console.log(this.page);
          this.pageCount = response.data.meta.last_page;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchData();
    window.addEventListener('scroll', () => {
      if ((window.innerHeight + window.scrollY) + 30 >= document.body.offsetHeight) {
        console.log('bottom of the page');
        if(this.reachedTheEnd) return;
        this.fetchData();
      }
    });
  }
};
</script>